module.exports = __webpack_public_path__ + "media/images/blank-1caffee03992ef40a8d4321e255692de.gif";